export const GENERIC_PHOTO_URL = 'https://s3-ap-southeast-2.amazonaws.com/aws.geogaming.io/teams/generic-photo.png'

export const GENERIC_MAP_PHOTO_URL = 'https://s3-ap-southeast-2.amazonaws.com/aws.geogaming.io/maps/generic-photo.png'

export default {
  GENERIC_PHOTO_URL,
  GENERIC_MAP_PHOTO_URL
}
